import { Injectable, OnInit } from '@angular/core';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ForgotPasswordModel } from 'src/app/pages/forgot-password/forgot-password.model';
import { J } from '@angular/cdk/keycodes';
import { JsonPipe } from '@angular/common';
import { LoginModel } from '../models/login.model';
import { Claims } from '../models/claims';
import { DrWebModules } from '../models/drweb-modules';
import { Utils } from '../utils';
import { Observable } from 'rxjs';
import { LogService } from 'src/app/shared/logService/log.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateService implements OnInit {

  // public loginModel: LoginModel;
  settings: Settings;
  apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;
  claims: Claims = new Claims([]);  
  modules: DrWebModules = new DrWebModules([]);
  forgotPassword: ForgotPasswordModel = new  ForgotPasswordModel();

  currentUser: any;


  constructor(private http: HttpClient,
    private appSettings: AppSettings,
    private route: ActivatedRoute,
    public router: Router,
    private logger: LogService) {
    this.settings = appSettings.settings;
  }


  ngOnInit(){
    if(!this.forgotPassword.Email){
      const tmp = sessionStorage.getItem('forgotPassword');
      if(tmp){
        this.forgotPassword = JSON.parse(tmp);
      }
    }
  }

  login(email: string, password: string) {    
    this.logger.debug("drWeb mobile AuthenticateService.login");
    const obj = {
      email: email,
      password: password
    };

    return this.http.post<any>(this.apiEndPoint + `AccountApi/Signin`, JSON.stringify(obj))
      .pipe(map(result => {
        
        if (result && result.Code === 1) {
          // success         
          sessionStorage.setItem('currentUser', JSON.stringify(result.Data));
          this.currentUser = result.Data;
         
          if(result.Data && result.Data.claims){
            this.claims = new Claims(result.Data.claims);
          }
          if(result.Data && result.Data.modules){
            this.modules = new DrWebModules(result.Data.modules)
          }
        }
        return result;
      }));
  }

  logout() : Observable<any> {
    this.logger.debug("drWeb mobile AuthenticateService.logout");
    return this.http.post<any>(this.apiEndPoint + `AccountApi/Signout`, '{}') 
      .pipe(map(result => {
        // this.loginModel = null;
        sessionStorage.removeItem('currentUser');
        this.currentUser = null;
        this.claims = null;
        this.modules = null;
        return result;
      }));
  }

  update(id: number, data: LoginModel) {
    // test only
    return this.http.put<any>(this.apiEndPoint + `AccountApi/${id}`, JSON.stringify(data))
      .pipe(map(result => {
        return result;
      }));
  }

  forgotPassword_requestToken(email: string) {
    this.logger.debug("drWeb mobile AuthenticateService.forgotPassword_requestToken");
    this.forgotPassword = new ForgotPasswordModel();
    this.forgotPassword.UserID = 0;
    this.forgotPassword.Email = email;
    // post
    return this.http.post<any>(this.apiEndPoint + `AccountApi/ForgotPasswordSendToken`, JSON.stringify(this.forgotPassword))
    .pipe(map(result => {

      if(result.Code === 1){
        
        Object.assign(this.forgotPassword, result.Data);
        sessionStorage.setItem('forgotPassword', JSON.stringify(this.forgotPassword));
      }
      return result;
    }));
  }

  forgotPassword_validateToken(token: string) {
    this.logger.debug("drWeb mobile AuthenticateService.forgotPassword_validateToken");
    this.forgotPassword.Token = token;
    // post
    return this.http.post<any>(this.apiEndPoint + `AccountApi/ForgotPasswordValidateToken`, JSON.stringify(this.forgotPassword))
    .pipe(map(result => {
      if(result.Code ===1){
        Object.assign(this.forgotPassword, result.Data);
        sessionStorage.setItem('forgotPassword', JSON.stringify(this.forgotPassword));
      }
      return result;
    }));
  }

  forgotPassword_changePassword(password: string, confirmPassword:string) {
    this.forgotPassword.NewPassword = password;
    this.forgotPassword.ConfirmPassword = confirmPassword;
    
    if(!password || password !== confirmPassword){
      return;
    }

    // post
    return this.http.post<any>(this.apiEndPoint + `AccountApi/ChangePassword`, JSON.stringify(this.forgotPassword))
    .pipe(map(result => {
      if(result.Code === 1){
        Object.assign(this.forgotPassword, result.Data);
        sessionStorage.removeItem('forgotPassword');
      }
      return result;
    }));
  }

  setLanguage(culture:string){
    return this.http.post<any>(this.apiEndPoint + `AccountApi/SetLanguage`, JSON.stringify(culture))
    .pipe(map(result => {
      return result;
    }));
  }


  isModuleEnabled(){
   
    return this.http.get<any>(this.apiEndPoint + `AccountApi/IsModuleEnabled`)
    .pipe(map(result => {
      return result;
    }));
  }

  // hasPermission(claimType){
  //   if(!this.claims || this.claims.length === 0){
  //     return false;
  //   }
  //   if(!claimType){
  //     return false;
  //   }
    
  //   return this.claims.filter(x=> x.ClaimResourcesData === claimType).length > 0;
  // }
}



